import {OrderPlaceTabType} from '@px/enum/order';
import {CalculatorTabType} from '@px/enum/tab-pc';
import {OrderBookType} from '@px/enum/book';
import {PlaceOrderSide} from '@px/enum';
import {storageUtil} from '@px/helper/storage';

interface Pos {
  x: number;
  y: number;
}

type OrderSide = 'Normal' | 'Down' | 'Up';
type OrderBy = 'turnoverEv' | 'closeEp' | 'changePercent';

interface MarketSort {
  orderBy: OrderBy;
  orderSide: OrderSide;
}

interface SpotStorage extends StorageObject {
  calculatorDialogPos: Pos;
  calculatorTabType: CalculatorTabType;
  placeOrderSide: PlaceOrderSide;
  placeOrderTabType: OrderPlaceTabType;
  orderBookType: OrderBookType;
  advancedIsShow: boolean;
  hideOtherSymbols: boolean;
  lastSymbol: string;
  quickPlaceMarketOrder: Pos;
  marketSort: MarketSort;
}

const STORAGE_KEY = 'spot_storage';

export const spotStorage = {
  readSpotStorage(): SpotStorage {
    return storageUtil.readStorageObject(STORAGE_KEY, createInitSpotStorage());
  },
  updateSpotStorage(kv) {
    storageUtil.writeStorageObject(STORAGE_KEY, {...spotStorage.readSpotStorage(), ...kv});
  },
};

function createInitSpotStorage(): SpotStorage {
  return {
    version: 1,
    calculatorDialogPos: null,
    calculatorTabType: CalculatorTabType.ProfitLoss,
    placeOrderSide: PlaceOrderSide.Right,
    placeOrderTabType: OrderPlaceTabType.Limit,
    orderBookType: OrderBookType.Stack,
    advancedIsShow: false,
    hideOtherSymbols: false,
    lastSymbol: '',
    quickPlaceMarketOrder: null,
    marketSort: {orderSide: 'Normal', orderBy: 'turnoverEv'},
  };
}
